import { loginResponse } from './../../models/account/loginResponse';
import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StyleClassModule } from 'primeng/styleclass';
import { TabViewModule } from 'primeng/tabview';
import { AvatarModule } from 'primeng/avatar';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { CommonModule } from '@angular/common';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AuthService } from '../../services/account/auth.service';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';
import { MessageService } from 'primeng/api';
import { JwtPayload, jwtDecode } from 'jwt-decode';
import { DecodedToken } from '../../guards/permission.guard';
import { AuthRoles, AuthRolesDescriptions } from '../../models/enums/enums';
import { SocialLoginComponent } from "../social-login/social-login.component";

interface slider {
  image: string,
  heading: string,
  description: string
}

interface Testimonial {
  name: string;
  subtitle?: string;
  quote: string;
}


@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [CarouselModule, RouterModule, FormsModule, InputNumberModule, ButtonModule, InputGroupModule, InputGroupAddonModule, InputTextModule, DropdownModule, SelectButtonModule, StyleClassModule, TabViewModule, AvatarModule, DividerModule, SocialLoginComponent, PasswordModule, CommonModule, IconFieldModule, InputIconModule],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})



export class SignInComponent implements OnInit, OnDestroy {
  testimonials: Testimonial[] = [
    {
      name: 'Inderjyot',
      quote:
        'I am a Master student at Dalhousie University in Nova Scotia, Canada. I am proud of what I achieved but I can say with certainty that her guidance took me so far. She was instrumental in helping me decide my career vision, apply successfully to universities in Canada, preparing my SOPs and most importantly presenting myself as a candidate that universities would prefer.',
    },
    {
      name: 'Ashutosh',
      quote:
        'I am so happy to have been referred to ma’am. With her help and guidance with my admission - I applied to only 5 top of the line schools in Canada and the best thing is that I got accepted in all 5. I am now leaving to join University of Waterloo in Canada. I have absolutely no hesitation in saying that I could not have got in without her guidance. She has answers to all questions that me and my parents had. Her immense experience in this line is very impressive.',
    },
    {
      name: 'Lavanya',
      subtitle: 'Ex Modern School – University of Toronto – Scholarship Holder',
      quote:
        'The experience is synonymous with perfection. It’s like ma’am and sir put your dreams into perspective for you and help you achieve them. Everything happens with utmost precision. They are the best team, their advice is very precious and they’ll treat you like family. They know what they do. I got admitted to all my dream universities thanks to their combined effort and hard work. Cheers to them!',
    },
    {
      name: 'Aryan',
      subtitle: 'ME, Cornell University',
      quote:
        'I’m thrilled to share my admission to the Master of Engineering program at Cornell University for Fall 2026. A huge thank you to the Grad Pilots team for their invaluable support in helping me join Cornell’s Engineering Management program in Ithaca. I couldn’t have achieved this milestone without you!',
    },
    {
      name: 'Mankeert',
      subtitle: 'MS Finance, Wayne State',
      quote:
        'I am very thankful to you for the conversation and this test. For past few months I felt that none of the teacher understands a student by his abilities other than marks but today I am filled with gratitude because you deep dived in my personality and actually understood what I want. I promise you that I will try my best to practice the steps you guided me about. I am a bit shy in front of my parents that’s why I didn’t speak much today but I will surely approach you after my mid term examination and I will start working on myself.',
    },
  ];
  activeTestimonial = 0;
  private autoSlideHandle?: ReturnType<typeof setInterval>;

  sliderData: slider[] = [
    {
      image: "assets/images/login-slide-1.png",
      heading: "Ask Me Anything",
      description: "Clear your doubts with our state-of-the-art Co-pilot !"
    },
    {
      image: "assets/images/login-slide-2.png",
      heading: "Find the University that fits you best",
      description: "Explore a wide range  of universities and their offerings"
    },
    {
      image: "assets/images/login-slide-3.png",
      heading: "Connect with Mentors",
      description: "Reach your goals faster by scheduling sessions with people who’ve been down the same road"
    }
  ];
  responsiveOptions: any[] | undefined;

  justifyOptions: any[] = [
    { text: 'OTP' },
    { text: 'EMAIL' }
  ];

  constructor(private authService: AuthService,
    private router: Router, private store: Store,
    private messageService: MessageService,
    ) {
  }

  loading: boolean = false;
  isUserExists: boolean = false;
  email: string = "";
  password: string = "";

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    this.stopAutoSlide();
  }

  getInitials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
      return '';
    }
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  goToTestimonial(index: number): void {
    this.activeTestimonial = index;
    this.startAutoSlide();
  }

  nextTestimonial(): void {
    this.activeTestimonial =
      (this.activeTestimonial + 1) % this.testimonials.length;
  }

  prevTestimonial(): void {
    this.activeTestimonial =
      (this.activeTestimonial - 1 + this.testimonials.length) %
      this.testimonials.length;
  }

  private startAutoSlide(): void {
    this.stopAutoSlide();
    this.autoSlideHandle = setInterval(() => this.nextTestimonial(), 7000);
  }

  private stopAutoSlide(): void {
    if (this.autoSlideHandle) {
      clearInterval(this.autoSlideHandle);
      this.autoSlideHandle = undefined;
    }
  }

  onSubmit(form: any) {
    if(form.invalid) return;
    this.loading = true;
    // if (!this.isUserExists) {
    //   this.authService.validateEmail(this.email).subscribe({
    //     next: (response: validateEmailResponse) => {
    //       if (response.isAccountExists) {
    //         this.isUserExists = response.isAccountExists;
    //       }
    //       else {
    //         this.loading = false;
    //         this.messageService.add({ severity: 'error', summary: 'Unauthorized', detail: 'Please sign up first' });
    //         // this.store.dispatch(new UpdateEmailVerification({ email: this.email, emailVerified: false }));
    //         // this.router.navigate(['/signup']); // Adjust the path as needed
    //       }
    //       this.isUserExists = response.isAccountExists;
    //       this.loading = false;
    //     },
    //     error: (error) => {
    //       this.messageService.add({ severity: 'error', summary: 'Unauthorized', detail: error });
    //       this.loading = false;
    //     },
    //     complete: () => {
    //       this.loading = false;
    //     }
    //   });
    // }
    // else {
      this.authService.login({
        emailOrPhone: this.email,
        password: this.password
      }).subscribe({
        next: (response: loginResponse) => {
          if (response) {
            const decodedToken: DecodedToken = jwtDecode<DecodedToken>(response.token);
            const rolesClaim = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
            const roles: string[] = Array.isArray(rolesClaim) ? rolesClaim : rolesClaim ? [rolesClaim] : [];
            if (roles.some(role => role == AuthRolesDescriptions[AuthRoles.Student])) {
              localStorage.setItem("account", JSON.stringify(response));
              if (sessionStorage.getItem('roi_pending_calc')) {
                this.router.navigate(['/portal/roi-calculator']);
              } else {
                this.router.navigate(['/portal']);
              }
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Unauthorized', detail: 'You are not authorized to continue' });
            }
          }
          this.loading = false;
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: error.name, detail: error.message });
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  // }
}


